import { render, staticRenderFns } from "./BannerKV.vue?vue&type=template&id=761a697f&scoped=true"
import script from "./BannerKV.vue?vue&type=script&lang=js"
export * from "./BannerKV.vue?vue&type=script&lang=js"
import style0 from "./BannerKV.vue?vue&type=style&index=0&id=761a697f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761a697f",
  null
  
)

export default component.exports